import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelShell from '@/components/paineis/PainelShell';
import PainelQualidade from '@/components/paineis/qualidade/PainelQualidade';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { QualidadePayload } from '@/types/dashboards';

const buscarQualidade = (params: Record<string, string>) => dashboardsService.getEquiplexQualidade(params);

/**
 * Aba "Liberação da Qualidade" do painel da Equiplex (`/paineis/equiplex/qualidade`).
 *
 * Um registro por lote que entrou no CQ (ficha de CQ do Datasul): a fila de hoje por
 * tempo de espera, o prazo de liberação por máquina e por mês, e as fichas que ficaram
 * abertas no ERP. Mesma atualização do S&OP (06:00 e "Atualizar agora").
 *
 * Primeira aba com o filtro de período e produto (06/10/2026): o filtro mora na URL e o
 * servidor monta a aba de novo a partir dos fatos do snapshot.
 */
const EquiplexQualidadePage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<QualidadePayload>(buscarQualidade);
  return (
    <PainelShell
      estado={estado}
      prefixo="qualidade"
      origem="qualidade"
      titulo="Liberação da Qualidade"
      subtitulo="Lotes de produção no CQ: quanto tempo levam para sair, onde a fila está parada e o que ficou aberto no Datasul."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte, undefined, payload.frescor?.dados_ate)}
          <PainelQualidade key={id} payload={payload} cores={cores} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexQualidadePage;
